/**
 * Enum określający źródło pochodzenia regulaminu (Sposób jego utworzenia).
 */
export enum TermsType {
  /** Regulamin wygenerowany bezpośrednio w systemie.
   */
  GENERATED = 'GENERATED',

  /** Regulamin zaimportowany z zewnątrz.
   */
  IMPORTED = 'IMPORTED'
}

/**
 * Model reprezentujący dynamiczny parametr używany w szablonach regulaminów.
 */
export class TermsOfAgreementCustomParam {
  /** Tekst parametru / wartość do podstawienia. */
  public text: string;
}

/**
 * Model reprezentujący Regulamin Świadczenia Usług (Terms of Agreement) dla danego klienta.
 */
export class TermsOfAgreement {

  /** Unikalny identyfikator dokumentu. */
  public uuid: string;

  /** Data i czas utworzenia (ważne dla wersjonowania regulaminów). */
  public created: Date;

  /**
   * Gotowy, skompilowany tekst regulaminu (w HTML).
   * Używane, gdy `type` === 'GENERATED'. To ten tekst widzi pacjent w aplikacji mobilnej.
   */
  public value: string;

  /** Identyfikator administratora (User), który utworzył ten regulamin. */
  public createdByUUID: string;

  /** ID klienta biznesowego, zapewniające izolację danych. */
  public vClientUUID: string;

  /** Vetcode konkretnej placówki, której dotyczy ten regulamin (jeśli nie jest globalny dla całej sieci). */
  public vetcodeId: number;

  public jsonValue: string;

  /**
   * Typ regulaminu (Wygenerowany wewnętrznie vs Zaimportowany).
   */
  public type: TermsType;

  /**
   * Tablica parametrów niestandardowych (obiektów `TermsOfAgreementCustomParam`).
   * Zapisana w postaci stringa JSON. Przechowuje wartości dynamicznych zmiennych,
   * które zostały użyte w tym konkretnym regulaminie.
   */
  public customParamsJSON: string;

  /**
   * Identyfikator sesji importu.
   */
  public importSessionUUID: string;

  /**
   * Bezpośredni link do dokumentu.
   */
  public url: string;
}
